import { Routes } from "@angular/router";
import { RoutesEnum } from "./models/routes.enum";
import { PopupRouteComponent } from "./shared/components/popup-route/popup-route.component";
import { RedirectRouteComponent } from "./shared/components/redirect-route/redirect-route.component";
import { RedirectService } from "./shared/services/redirect/redirect.service";

export const routes: Routes = [
  // 1️⃣ Popup-Outlets IMMER zuerst
  {
    path: "newsletter",
    outlet: "popup",
    component: PopupRouteComponent,
  },
  {
    path: "contact",
    outlet: "popup",
    component: PopupRouteComponent,
  },

  // Redirect-Guard für externe Links
  {
    path: "redirect",
    canActivate: [RedirectService],
    component: RedirectRouteComponent,
  },

  // 2️⃣ Redirect NACH den spezifischen Routen
  {
    path: "",
    redirectTo: "home",
    pathMatch: "full",
  },

  // 3️⃣ Dynamic Catch-all IMMER ganz am Ende
  {
    path: RoutesEnum.Dynamic,
    loadComponent: () =>
      import("./dynamic-page/dynamic-page.component").then(
        (m) => m.DynamicPageComponent
      ),
  },
];
